import { useEffect, useMemo, useRef, useState } from 'react'
import { LinearProgress } from '@mui/material'
import { ICONE, WizardSincronizzatoConRotta, BaseFeedbackConIcona, BaseContenutoConProgress, BaseGridLayout } from '@lucan/base-ui'
import { OPERAZIONI, useVerbale } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import ConfigManager from 'components/config/ConfigManager'
import Testo from 'components/ui/Testo'
import Titolo from 'components/ui/Titolo'
import TitoloTab from 'components/ui/TitoloTab'
import { useVerbaliContext } from 'context/VerbaliProvider'
import FrontofficeContenitore from '../FrontofficeContenitore'
import DatiPersonali from './DatiPersonali'
import Informativa from './Informativa'
import Riepilogo from './Riepilogo'
import SceltaPagamento from './SceltaPagamento'
import useAvvioPagamento from './useAvvioPagamento'
import { calcolaStatoPagamentoVerbale, isPagamentoPagato, STATO_PAGAMENTO_VERBALE } from '../utilFrontoffice'
import ListaVerbaliWizard from './ListaVerbali'
import BreadcrumbsFrontOffice from 'components/ui/frontoffice/BreadcrumbsFrontOffice'
import Preavviso from './Preavviso'
import Sezione from 'components/ui/Sezione'
import { FRONTOFFICE_CONDIVISO, FRONTOFFICE_VERBALE } from 'configuration/frontoffice'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import useStepVerbale from './useStepVerbale'
import useLogout from 'hook/useLogout'
import useSchermoStretto from 'hook/useSchermoStretto'

const CFG = FRONTOFFICE_VERBALE
const CFG_C = FRONTOFFICE_CONDIVISO

const CHIAVI_TABS = {
  INFORMATIVA: 'informativa',
  DATI_PERSONALI: 'datiPersonali',
  LISTA_VERBALI: 'listaVerbali',
  DATI_VERBALE: 'datiVerbale',
  DATI_PAGAMENTO: 'datiPagamento',
  RIEPILOGO: 'riepilogo',
}
Verbale.CHIAVI_TABS = CHIAVI_TABS

export default function Verbale() {
  return (
    <ConfigManager elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_VERBALE, ELENCHI.CFG_FRONTOFFICE_CONDIVISO]}>
      {propsConfig => <VerbaleInterno {...propsConfig} />}
    </ConfigManager>
  )
}



function VerbaleInterno(props) {
  const { val } = props
  const { showPreavviso } = useVerbaliContext()
  const [messaggioErrore, setMessaggioErrore] = useState(null)
  const [datiPersonali, setDatiPersonali] = useState(null)
  const [rispostaDatiPersonaliOttenuta, setRispostaDatiPersonaliOttenuta] = useState(false)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function getDatiPersonaliSeCiSono() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.DATI_VERBALE_EXTRA)
      if (ok) {
        if (data.esito) setDatiPersonali(data.data)
        setRispostaDatiPersonaliOttenuta(true)
      }
    }
    getDatiPersonaliSeCiSono()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { BottoneLogout } = useLogout({
    testoBottone: val(CFG.BOTTONI_ESCI_DAL_VERBALE)
  })

  const preavvisoRef = useRef()

  return (
    <FrontofficeContenitore>
      <BaseGridLayout justifySpaceBetween alignCenter>
        <BreadcrumbsFrontOffice conf={val(CFG.BREADCRUMBS, {}, true)} />
        {BottoneLogout}
      </BaseGridLayout>

      {ScatolaMessaggi}
      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {rispostaDatiPersonaliOttenuta &&
          <VerbaleWizard
            datiPersonali={datiPersonali}
            preavvisoRef={preavvisoRef}
            {...props}
          />
        }
      </BaseContenutoConProgress>

      {showPreavviso && val(CFG_C.PREAVVISO) &&
        <Sezione sx={{ mt: 4 }}>
          <Preavviso inputRef={preavvisoRef} />
        </Sezione>
      }
    </FrontofficeContenitore>
  )
}



function VerbaleWizard(props) {
  const { datiPersonali, preavvisoRef, val, txt } = props

  const { chiaveVerbale, isModalitaWeb, verbale, salvaVerbale } = useVerbaliContext()

  const {
    informativaAccettata,
    setInformativaAccettata,
    datiPersonaliCf,
    setDatiPersonaliCf,
    chiaveScelta,
    setChiaveScelta,
    datiVerbaleVisti,
    setDatiVerbaleVisti,
    codiceAvvisoScelto,
    setCodiceAvvisoScelto
  } = useStepVerbale({
    codiceFiscale: datiPersonali?.codiceFiscale,
    chiaveVerbale,
    //chiaveScelta
  })

  const {
    ScatolaMessaggi,
    getVerbale: getVerbaleFetch,
    inAttesaDelServer
  } = useVerbale({ conCookie: true })

  useEffect(() => {
    async function getVerbale() {
      const { ok, data } = await getVerbaleFetch(chiaveScelta)
      const { esito, messaggio, verbale: verbaleNuovo } = ok ? data : {}
      if (ok && esito) {
        salvaVerbale(verbaleNuovo)
      }
    }

    if (!verbale && chiaveScelta) {
      getVerbale()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiaveScelta])

  const vaiAlVerbale = (chiave) => {
    setChiaveScelta(chiave)
    setCodiceAvvisoScelto('')
    setDatiVerbaleVisti(false)
  }

  const {
    avviaPagamento,
    inAttesaPagamento,
    ScatolaMessaggiPagamento
  } = useAvvioPagamento({ codiceAvviso: codiceAvvisoScelto, chiave: chiaveScelta })

  const stato = calcolaStatoPagamentoVerbale(verbale)
  const statoPagato = (stato === STATO_PAGAMENTO_VERBALE.PAGATO || stato == STATO_PAGAMENTO_VERBALE.NON_PAGABILE)

  const schermoStretto = useSchermoStretto()

  const {
    logout,
    inAttesaLogout,
    ScatolaMessaggiLogout
  } = useLogout()

  const tabs = useMemo(() => {
    return [
      {
        chiave: CHIAVI_TABS.INFORMATIVA,
        titolo: <TitoloTab Icona={ICONE.NOTIZIA} titolo={txt(CFG.TABS_INFORMATIVA)} />,
        Contenuto: () => (
          <Informativa
            informativaAccettata={informativaAccettata}
            setInformativaAccettata={setInformativaAccettata}
          />
        ),
        propsBottoneIndietro: {
          ...(inAttesaLogout && { inAttesa: true, disabled: true })
        },
      },
      ...(datiPersonali ? [{
        chiave: CHIAVI_TABS.DATI_PERSONALI,
        titolo: <TitoloTab Icona={ICONE.PERSONA} titolo={txt(CFG.TABS_DATI_PERSONALI)} />,
        Contenuto: () => (
          <DatiPersonali
            datiPersonali={datiPersonali}
            datiPersonaliCf={datiPersonaliCf}
            setDatiPersonaliCf={setDatiPersonaliCf}
          />
        ),
        validate: { condition: () => informativaAccettata },
      }] : []),
      ...(!isModalitaWeb ? [{
        chiave: CHIAVI_TABS.LISTA_VERBALI,
        titolo: <TitoloTab Icona={ICONE.LISTA} titolo={txt(CFG.TABS_LISTA_VERBALI)} />,
        Contenuto: () => (
          <ListaVerbaliWizard
            vaiAlVerbale={vaiAlVerbale}
            chiave={chiaveScelta}
            preavvisoRef={preavvisoRef}
          />
        ),
        validate: { condition: () => informativaAccettata && datiPersonaliCf },
      }] : []),
      {
        chiave: CHIAVI_TABS.DATI_VERBALE,
        titolo: <TitoloTab Icona={ICONE.CERCA} titolo={txt(CFG.TABS_DATI_VERBALE)} />,
        Contenuto: () => verbale && (
          <DatiVerbale
            chiaveVerbale={chiaveScelta}
            verbale={verbale}
            statoPagato={statoPagato}
            setDatiVerbaleVisti={setDatiVerbaleVisti}
          />
        ),
        validate: { condition: () => informativaAccettata && datiPersonaliCf && chiaveScelta },
      },
      {
        chiave: CHIAVI_TABS.DATI_PAGAMENTO,
        titolo: <TitoloTab Icona={ICONE.PAGAMENTO} titolo={txt(CFG.TABS_DATI_PAGAMENTO)} />,
        Contenuto: () => verbale && (
          <SceltaPagamento
            codiceAvvisoScelto={codiceAvvisoScelto}
            setCodiceAvvisoScelto={setCodiceAvvisoScelto}
            pagamenti={verbale.pagamenti}
          />
        ),
        validate: { condition: () => !statoPagato && informativaAccettata && datiPersonaliCf && datiVerbaleVisti },
      },
      {
        chiave: CHIAVI_TABS.RIEPILOGO,
        titolo: <TitoloTab Icona={ICONE.INFO} titolo={txt(CFG.TABS_RIEPILOGO)} />,
        Contenuto: () => verbale && (
          <Riepilogo
            chiaveVerbale={chiaveScelta}
            verbale={verbale}
            pagamento={verbale.pagamenti.find(({ codice_avviso }) => codiceAvvisoScelto === codice_avviso)}
          />
        ),
        validate: { condition: () => !statoPagato && informativaAccettata && datiPersonaliCf && datiVerbaleVisti && codiceAvvisoScelto },
        propsBottoneAvanti: {
          testo: schermoStretto ? val(CFG.BOTTONI_PAGA) : val(CFG.BOTTONI_CONFERMA_E_PAGA),
          ...(inAttesaPagamento && { inAttesa: true, disabled: true })
        },
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schermoStretto, informativaAccettata, verbale, codiceAvvisoScelto, datiVerbaleVisti, inAttesaPagamento, statoPagato, chiaveScelta, isModalitaWeb, datiPersonali, datiPersonaliCf, inAttesaLogout])

  return (
    <>
      <Titolo>{txt(CFG.TITOLO)}</Titolo>
      <Testo sx={{ mb: 3 }}>{txt(statoPagato ? CFG.SOTTOTITOLO_PAGATO : CFG.SOTTOTITOLO)}</Testo>

      {inAttesaDelServer && <LinearProgress />}

      <WizardSincronizzatoConRotta
        smallMode={'sm'}
        tabs={tabs}
        chiaveRottaBase={CHIAVI_ROUTES.FRONTOFFICE_VERBALE}
        {...(!statoPagato && { onClickBottoneAvantiUltimaTab: avviaPagamento })}
        onClickBottoneIndietroPrimaTab={logout}
        labelBottoneAvanti={val(CFG.BOTTONI_AVANTI)}
        labelBottoneIndietro={val(CFG.BOTTONI_INDIETRO)}
        {...(schermoStretto && { orientation: 'vertical', noPaddingX: true })}
      />

      {ScatolaMessaggiPagamento}
      {ScatolaMessaggi}
      {ScatolaMessaggiLogout}
    </>
  )
}



function DatiVerbale(props) {
  const { chiaveVerbale, verbale, statoPagato, setDatiVerbaleVisti } = props

  useEffect(() => {
    setDatiVerbaleVisti(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Riepilogo
      chiaveVerbale={chiaveVerbale}
      verbale={verbale}
      {...(statoPagato && { pagamentoPagato: verbale.pagamenti.find(isPagamentoPagato) })}
    />
  )
}